module.exports = __webpack_public_path__ + "img/cardiology.af46b586.png";